// import React, { useState } from "react";
// import { RiGolfBallLine } from "react-icons/ri";
// import { MdEmail } from "react-icons/md";
// import { FaPhoneVolume } from "react-icons/fa6";
// import { IoIosTime } from "react-icons/io";
// import { IoLocation } from "react-icons/io5";
// import { toast } from "react-hot-toast";
// import api from "../api/axiosInstance";

// const Contact = () => {
//   const [formData, setFormData] = useState({
//     firstName: "",
//     lastName: "",
//     phoneNumber: "",
//     email: "",
//     message: "",
//   });
//   const [loading, setLoading] = useState(false);

//   const handleChange = (e) => {
//     setFormData({
//       ...formData,
//       [e.target.name]: e.target.value,
//     });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     setLoading(true);

//     try {
//       await api.post("/contact/submit", formData);
//       toast.success("Message sent successfully!");

//       // Reset form
//       setFormData({
//         firstName: "",
//         lastName: "",
//         phoneNumber: "",
//         email: "",
//         message: "",
//       });
//     } catch (error) {
//       console.error("Error sending message:", error);
//       toast.error("Failed to send message. Please try again.");
//     } finally {
//       setLoading(false);
//     }
//   };

//   return (
//     <div className="bg-[#fffdf7] py-20 px-6 md:px-20">
//       <div className="grid md:grid-cols-2 gap-10">
//         {/* Left Column - Contact Info */}
//         <div>
//           <p className="text-sm font-semibold tracking-widest flex items-center gap-2 mb-4">
//             <span>
//               <RiGolfBallLine className="bg-yellow-100 rounded-[50px]" />
//             </span>{" "}
//             CONTACT US
//           </p>
//           <h2 className="text-4xl md:text-5xl font-bold mb-6 text-black">
//             Your <span className="relative inline-block">golf</span> journey
//             starts <br /> right here
//           </h2>

//           <hr className="border-t border-gray-200 my-6" />

//           <div className="grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-6 text-black/80 mt-6">
//             {/* Email */}
//             <div className="flex items-start gap-3">
//               <span className="text-xl">
//                 <MdEmail />
//               </span>
//               <div>
//                 <h4 className="font-semibold text-black">Email</h4>
//                 <p>rgcc66div@gmail.com</p>
//                 <p>support@rgcc.com</p>
//               </div>
//             </div>

//             {/* Contact Us */}
//             <div className="flex items-start gap-3">
//               <span className="text-xl">
//                 <FaPhoneVolume />
//               </span>
//               <div>
//                 <h4 className="font-semibold text-black">Contact Us</h4>
//                 <p>+880 1766693142</p>
//               </div>
//             </div>

//             {/* Working Hours */}
//             <div className="flex items-start gap-3">
//               <span className="text-xl">
//                 <IoIosTime />
//               </span>
//               <div>
//                 <h4 className="font-semibold text-black">Working Hours</h4>
//                 <p>Mon - Sat : 7:00 AM to 5:00 PM</p>
//                 <p>Sunday : Close</p>
//               </div>
//             </div>

//             {/* Location */}
//             <div className="flex items-start gap-3">
//               <span className="text-xl">
//                 <IoLocation />
//               </span>
//               <div>
//                 <h4 className="font-semibold text-black">Location</h4>
//                 <p>Ghaghat, Rangpur (Near Ghaghat Bridge)</p>
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* Right Column - Form */}
//         <div className="bg-[#fcfaec] rounded-xl p-6 md:p-10">
//           <h3 className="text-3xl font-bold mb-6 text-black">
//             Get in touch with us !
//           </h3>
//           <form className="space-y-4" onSubmit={handleSubmit}>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <input
//                 type="text"
//                 name="firstName"
//                 placeholder="First Name"
//                 value={formData.firstName}
//                 onChange={handleChange}
//                 required
//                 className="p-3 rounded bg-white w-full outline-none"
//               />
//               <input
//                 type="text"
//                 name="lastName"
//                 placeholder="Last Name"
//                 value={formData.lastName}
//                 onChange={handleChange}
//                 required
//                 className="p-3 rounded bg-white w-full outline-none"
//               />
//             </div>
//             <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//               <input
//                 type="text"
//                 name="phoneNumber"
//                 placeholder="Phone Number"
//                 value={formData.phoneNumber}
//                 onChange={handleChange}
//                 required
//                 className="p-3 rounded bg-white w-full outline-none"
//               />
//               <input
//                 type="email"
//                 name="email"
//                 placeholder="Email"
//                 value={formData.email}
//                 onChange={handleChange}
//                 required
//                 className="p-3 rounded bg-white w-full outline-none"
//               />
//             </div>
//             <textarea
//               name="message"
//               rows="4"
//               placeholder="Write Message..."
//               value={formData.message}
//               onChange={handleChange}
//               required
//               className="p-3 rounded bg-white w-full outline-none"
//             ></textarea>
//             <button
//               type="submit"
//               disabled={loading}
//               className={`${
//                 loading
//                   ? "bg-gray-400 cursor-not-allowed"
//                   : "bg-lime-400 hover:bg-black hover:text-white"
//               } w-full uppercase py-3 rounded-full font-bold text-black transition`}
//             >
//               {loading ? "Sending..." : "Submit Message"}
//             </button>
//           </form>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Contact;

import React, { useEffect, useRef, useState } from "react";
import { RiGolfBallLine } from "react-icons/ri";
import { MdEmail } from "react-icons/md";
import { FaPhoneVolume, FaMapMarkerAlt } from "react-icons/fa";
import { IoIosTime, IoIosArrowForward } from "react-icons/io";
import { toast } from "react-hot-toast";
import api from "../api/axiosInstance";

const Contact = () => {
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    phoneNumber: "",
    email: "",
    message: "",
  });
  const [loading, setLoading] = useState(false);
  const [focusedField, setFocusedField] = useState(null);

  const contactRef = useRef(null);

  useEffect(() => {
    // Scroll the form into view once on mount only - without the empty
    // dependency array this re-ran on every render (including every
    // keystroke while typing), continually yanking the page back.
    const timer = setTimeout(() => {
      if (contactRef.current) {
        contactRef.current.scrollIntoView({
          behavior: "smooth",
          block: "center",
        });
      }
    }, 1000);
    return () => clearTimeout(timer);
  }, []);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleFocus = (field) => {
    setFocusedField(field);
  };

  const handleBlur = () => {
    setFocusedField(null);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await api.post("/contact/submit", formData);
      toast.success("Message sent successfully!");

      // Reset form
      setFormData({
        firstName: "",
        lastName: "",
        phoneNumber: "",
        email: "",
        message: "",
      });
    } catch (error) {
      console.error("Error sending message:", error);
      toast.error("Failed to send message. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  const contactInfo = [
    {
      icon: <MdEmail className="w-6 h-6" />,
      title: "Email Address",
      details: ["rgcc66div@gmail.com"],
      color: "from-emerald-500 to-emerald-400",
      bg: "bg-emerald-50",
      border: "border-emerald-100",
    },
    {
      icon: <FaPhoneVolume className="w-5 h-5" />,
      title: "Contact Number",
      details: ["+880 1769663142"],
      color: "from-lime-500 to-lime-400",
      bg: "bg-lime-50",
      border: "border-lime-100",
    },
    {
      icon: <IoIosTime className="w-6 h-6" />,
      title: "Working Hours",
      details: ["Mon - Sat: 7:00 AM to 5:00 PM", "Sunday: Closed"],
      color: "from-amber-500 to-amber-400",
      bg: "bg-amber-50",
      border: "border-amber-100",
    },
    {
      icon: <FaMapMarkerAlt className="w-5 h-5" />,
      title: "Location",
      details: ["Ghaghat, Rangpur", "(Near Ghaghat Bridge)"],
      color: "from-blue-500 to-blue-400",
      bg: "bg-blue-50",
      border: "border-blue-100",
    },
  ];

  return (
    <div className="min-h-screen bg-gradient-to-br from-emerald-50 via-white to-lime-50 py-12 md:py-20 px-4 sm:px-6 lg:px-8">
      {/* Decorative Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        <div className="absolute -top-24 -right-24 w-64 h-64 bg-emerald-100 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute -bottom-24 -left-24 w-72 h-72 bg-lime-100 rounded-full opacity-20 blur-3xl"></div>
        <div className="absolute top-1/3 left-10 w-16 h-16 bg-emerald-200 rounded-full opacity-10"></div>
        <div className="absolute bottom-1/4 right-10 w-20 h-20 bg-lime-200 rounded-full opacity-10"></div>
      </div>

      <div className="relative max-w-7xl mx-auto">
        {/* Header Section */}
        <div className="text-center mb-12 md:mb-16">
          <div className="inline-flex items-center justify-center mb-4">
            <div className="relative">
              <div className="absolute inset-0 bg-gradient-to-r from-emerald-400 to-lime-400 rounded-full blur-lg opacity-30"></div>
              <div className="relative w-16 h-16 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 border-2 border-emerald-100 flex items-center justify-center">
                <RiGolfBallLine className="w-8 h-8 text-emerald-600" />
              </div>
            </div>
          </div>
          <p className="text-sm font-semibold tracking-widest text-emerald-600 uppercase mb-3">
            Get In Touch
          </p>
          <h1 className="text-4xl md:text-5xl lg:text-6xl font-bold text-gray-900 mb-4">
            Let's Connect on the{" "}
            <span className="relative inline-block">
              <span className="relative z-10">Green</span>
              {/* <span className="absolute bottom-2 left-0 w-full h-3 bg-gradient-to-r from-emerald-300 to-lime-300 opacity-50 -rotate-1"></span> */}
            </span>
          </h1>
          <p className="text-gray-600 text-lg md:text-xl max-w-3xl mx-auto">
            Reach out to us for inquiries, membership details, or to schedule
            your next visit
          </p>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 lg:gap-12">
          {/* Left Column - Contact Info & Cards */}
          <div>
            <div ref={contactRef} className="mb-10">
              <h2 className="text-2xl md:text-3xl font-bold text-gray-900 mb-6">
                Our Contact Information
              </h2>
              <p className="text-gray-600 mb-8">
                Whether you're looking to join our club, book an event, or just
                want to chat about golf, we're here to help.
              </p>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-10">
              {contactInfo.map((item, index) => (
                <div
                  key={index}
                  className={`${item.bg} ${item.border} rounded-2xl border p-5 hover:shadow-xl transition-all duration-300 hover:-translate-y-1`}
                >
                  <div className="flex items-start space-x-4">
                    <div
                      className={`w-12 h-12 rounded-xl bg-gradient-to-br ${item.color} flex items-center justify-center flex-shrink-0 shadow-md`}
                    >
                      <div className="text-white">{item.icon}</div>
                    </div>
                    <div className="flex-1">
                      <h3 className="font-bold text-gray-900 mb-2">
                        {item.title}
                      </h3>
                      {item.details.map((detail, idx) => (
                        <p key={idx} className="text-gray-600 text-sm mb-1">
                          {detail}
                        </p>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Map Preview */}
            <div className="rounded-2xl overflow-hidden border border-gray-200 shadow-lg">
              <div className="bg-gradient-to-r from-emerald-500 to-lime-500 p-4">
                <h3 className="text-white font-bold flex items-center">
                  <FaMapMarkerAlt className="w-5 h-5 mr-2" />
                  Visit Our Location
                </h3>
              </div>
              <div className="p-6 bg-white">
                <p className="text-gray-700 mb-4">
                  Located in the picturesque Ghaghat area of Rangpur, our club
                  offers world-class facilities with breathtaking views.
                </p>
                <div className="flex items-center text-emerald-600 font-medium">
                  <span>Get Directions</span>
                  <IoIosArrowForward className="w-4 h-4 ml-2" />
                </div>
              </div>
            </div>
          </div>

          {/* Right Column - Contact Form */}
          <div className="relative">
            <div className="bg-white/90 backdrop-blur-sm rounded-2xl shadow-2xl overflow-hidden border border-emerald-100">
              {/* Top accent bar */}
              <div className="h-2 bg-gradient-to-r from-emerald-400 via-lime-400 to-emerald-400"></div>

              <div className="p-6 md:p-8">
                <div className="text-center mb-8">
                  <h3 className="text-3xl font-bold text-gray-900 mb-3">
                    Send Us a Message
                  </h3>
                  <p className="text-gray-600">
                    Fill out the form below and we'll get back to you soon.
                    hours
                  </p>
                </div>

                <form className="space-y-6" onSubmit={handleSubmit}>
                  {/* Name Fields */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <div className="relative group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        First Name
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          name="firstName"
                          placeholder="John"
                          value={formData.firstName}
                          onChange={handleChange}
                          onFocus={() => handleFocus("firstName")}
                          onBlur={handleBlur}
                          required
                          className={`w-full pl-4 pr-4 py-3.5 rounded-xl bg-white border-2 transition-all duration-300 outline-none ${
                            focusedField === "firstName"
                              ? "border-emerald-400 shadow-lg shadow-emerald-100"
                              : "border-gray-200 hover:border-emerald-300"
                          }`}
                        />
                      </div>
                    </div>

                    <div className="relative group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Last Name
                      </label>
                      <div className="relative">
                        <input
                          type="text"
                          name="lastName"
                          placeholder="Doe"
                          value={formData.lastName}
                          onChange={handleChange}
                          onFocus={() => handleFocus("lastName")}
                          onBlur={handleBlur}
                          required
                          className={`w-full pl-4 pr-4 py-3.5 rounded-xl bg-white border-2 transition-all duration-300 outline-none ${
                            focusedField === "lastName"
                              ? "border-emerald-400 shadow-lg shadow-emerald-100"
                              : "border-gray-200 hover:border-emerald-300"
                          }`}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Contact Fields */}
                  <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
                    <div className="relative group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Phone Number
                      </label>
                      <div className="relative">
                        <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                          <FaPhoneVolume className="w-4 h-4" />
                        </div>
                        <input
                          type="tel"
                          name="phoneNumber"
                          placeholder="+880 1769-663142"
                          value={formData.phoneNumber}
                          onChange={handleChange}
                          onFocus={() => handleFocus("phone")}
                          onBlur={handleBlur}
                          required
                          className={`w-full pl-12 pr-4 py-3.5 rounded-xl bg-white border-2 transition-all duration-300 outline-none ${
                            focusedField === "phone"
                              ? "border-emerald-400 shadow-lg shadow-emerald-100"
                              : "border-gray-200 hover:border-emerald-300"
                          }`}
                        />
                      </div>
                    </div>

                    <div className="relative group">
                      <label className="block text-sm font-semibold text-gray-700 mb-2">
                        Email Address
                      </label>
                      <div className="relative">
                        <div className="absolute left-4 top-1/2 transform -translate-y-1/2 text-gray-400">
                          <MdEmail className="w-4 h-4" />
                        </div>
                        <input
                          type="email"
                          name="email"
                          placeholder="john.doe@example.com"
                          value={formData.email}
                          onChange={handleChange}
                          onFocus={() => handleFocus("email")}
                          onBlur={handleBlur}
                          required
                          className={`w-full pl-12 pr-4 py-3.5 rounded-xl bg-white border-2 transition-all duration-300 outline-none ${
                            focusedField === "email"
                              ? "border-emerald-400 shadow-lg shadow-emerald-100"
                              : "border-gray-200 hover:border-emerald-300"
                          }`}
                        />
                      </div>
                    </div>
                  </div>

                  {/* Message Field */}
                  <div className="relative group">
                    <label className="block text-sm font-semibold text-gray-700 mb-2">
                      Your Message
                    </label>
                    <div className="relative">
                      <textarea
                        name="message"
                        rows="5"
                        placeholder="Tell us about your inquiry or how we can help you..."
                        value={formData.message}
                        onChange={handleChange}
                        onFocus={() => handleFocus("message")}
                        onBlur={handleBlur}
                        required
                        className={`w-full pl-4 pr-4 py-3.5 rounded-xl bg-white border-2 transition-all duration-300 outline-none resize-none ${
                          focusedField === "message"
                            ? "border-emerald-400 shadow-lg shadow-emerald-100"
                            : "border-gray-200 hover:border-emerald-300"
                        }`}
                      ></textarea>
                    </div>
                  </div>

                  {/* Submit Button */}
                  <button
                    type="submit"
                    disabled={loading}
                    className="group relative w-full py-4 px-6 rounded-xl font-bold text-white bg-gradient-to-r from-emerald-500 to-lime-500 hover:from-emerald-600 hover:to-lime-600 transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed transform hover:-translate-y-0.5 shadow-lg hover:shadow-xl"
                  >
                    <div className="absolute inset-0 rounded-xl bg-gradient-to-r from-emerald-400 to-lime-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                    <span className="relative flex items-center justify-center">
                      {loading ? (
                        <>
                          <svg
                            className="animate-spin -ml-1 mr-3 h-5 w-5 text-white"
                            fill="none"
                            viewBox="0 0 24 24"
                          >
                            <circle
                              className="opacity-25"
                              cx="12"
                              cy="12"
                              r="10"
                              stroke="currentColor"
                              strokeWidth="4"
                            ></circle>
                            <path
                              className="opacity-75"
                              fill="currentColor"
                              d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"
                            ></path>
                          </svg>
                          Sending Message...
                        </>
                      ) : (
                        <>
                          <svg
                            className="w-5 h-5 mr-3"
                            fill="currentColor"
                            viewBox="0 0 24 24"
                          >
                            <path d="M2.01 21L23 12 2.01 3 2 10l15 2-15 2z" />
                          </svg>
                          SEND MESSAGE
                        </>
                      )}
                    </span>
                  </button>

                  {/* Privacy Note */}
                  <p className="text-center text-gray-500 text-sm">
                    By submitting this form, you agree to our privacy policy. We
                    respect your privacy.
                  </p>
                </form>
              </div>
            </div>
          </div>
        </div>

        {/* Additional Information Section */}
        <div className="mt-16 md:mt-20 text-center">
          <div className="inline-flex items-center justify-center mb-6">
            <div className="w-16 h-16 rounded-full bg-gradient-to-br from-emerald-50 to-lime-50 border-2 border-emerald-100 flex items-center justify-center">
              <RiGolfBallLine className="w-8 h-8 text-emerald-600" />
            </div>
          </div>
          <h3 className="text-2xl md:text-3xl font-bold text-gray-900 mb-4">
            Why Choose Rangpur Golf & Country Club?
          </h3>
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 border border-emerald-100 shadow-sm">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-emerald-100 to-emerald-50 flex items-center justify-center mb-4 mx-auto">
                <svg
                  className="w-6 h-6 text-emerald-600"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z" />
                </svg>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">
                Premium Facilities
              </h4>
              <p className="text-gray-600 text-sm">
                World-class golf course with state-of-the-art amenities
              </p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 border border-emerald-100 shadow-sm">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-lime-100 to-lime-50 flex items-center justify-center mb-4 mx-auto">
                <svg
                  className="w-6 h-6 text-lime-600"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z" />
                </svg>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Expert Staff</h4>
              <p className="text-gray-600 text-sm">
                Professional guidance from experienced golf instructors
              </p>
            </div>
            <div className="bg-white/80 backdrop-blur-sm rounded-xl p-6 border border-emerald-100 shadow-sm">
              <div className="w-12 h-12 rounded-lg bg-gradient-to-br from-amber-100 to-amber-50 flex items-center justify-center mb-4 mx-auto">
                <svg
                  className="w-6 h-6 text-amber-600"
                  fill="currentColor"
                  viewBox="0 0 24 24"
                >
                  <path d="M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z" />
                </svg>
              </div>
              <h4 className="font-bold text-gray-900 mb-2">Flexible Hours</h4>
              <p className="text-gray-600 text-sm">
                Convenient scheduling to fit your busy lifestyle
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Contact;
